import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import {
  Alert,
  Box,
  Button, Collapse, Dialog, DialogActions,
  DialogContent, DialogTitle,
  IconButton,
  MenuItem, TextField,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import TitleLink from '../../components/TitleLink';
import { formatPhoneNumber } from '../../utils/utils'
import { API_STATUS, COLOR, USER_TYPE, BASE_URL } from '../../constants';
import { getUsers, createUser } from '../../api/APIServices'
import Search from '../../components/Search'
import { Link, useNavigate } from 'react-router-dom';
import { sort, resetFilter } from '../../redux/slices/usersSlice'
import { resetUserDeletedFlag } from '../../redux/slices/userSlice'

function Users() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const { users, status, isFilter, filteredUsers } = useSelector((state) => state.users);
  const { isUserDeleted } = useSelector((state) => state.user);

  const initialFormValues = { email: '', firstName: '', lastName: '', gender: 'male', phone: '' };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const [dob, setDob] = useState(Date.now());
  const [isAsc, setIsAsc] = useState(true);
  const [openAddUser, setOpenAddUser] = useState(false);
  const handleClickOpenAddUser = () => {
    setOpenAddUser(true);
  };
  const handleCloseAddUser = () => {
    setOpenAddUser(false);
  };

  useEffect(() => {
    dispatch(getUsers());
    return () => {
      dispatch(resetFilter());
    }
  }, []);

  useEffect(() => {
    if (status === API_STATUS.SUCCESS) {
      dispatch(getUsers());
    }
  }, [status])

  function handleChange(e) {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    setIsSubmit(true)
  }

  function validate(values) {
    const error = {}

    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
    if (!values.email) {
      error.email = 'email is required';
    } else if (!regex.test(values.email)) {
      error.email = 'enter valid email format';
    }
    if (!values.firstName.trim()) {
      error.firstName = 'First name is required';
    }
    if (!values.lastName.trim()) {
      error.lastName = 'Last name is required';
    }
    if (!values.phone.trim()) {
      error.phone = 'Phone number is required';
    }
    return error;
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      if (typeof (dob) == 'number') {
        return alert('Please Select DOB.')
      } else {
        let postData = {
          ...formValues,
          dob: dob?.format("YYYY-MM-DD")
        }
        dispatch(createUser(postData));
        handleCloseAddUser();
      }
    }
  }, [formErrors]);

  function reset() {
    dispatch(resetFilter());
  }


  //SORT DATA
  const sortBy = (sortField = 'enrollmentDate', isAsc) => {
    setIsAsc(!isAsc);
    let element = 'users'
    // dispatch(sort({ data, sortField, isAsc, element }));
    dynamicSort(data, sortField, isAsc, element)
  }
  const dynamicSort = (OldData, sortField, isAsc) => {
    setData([]);

    const dataFilter = [...OldData].sort((a, b) => {
      const valA = a[sortField];
      const valB = b[sortField];

      if (valA === undefined || valB === undefined) return 0;

      // Handle Date
      if (isValidDate(valA) && isValidDate(valB)) {
        const dateA = new Date(valA);
        const dateB = new Date(valB);
        return isAsc ? dateA - dateB : dateB - dateA;
      }

      // Handle Number
      if (!isNaN(valA) && !isNaN(valB)) {
        return isAsc ? valA - valB : valB - valA;
      }

      // Handle String
      const strA = valA.toString().toLowerCase();
      const strB = valB.toString().toLowerCase();

      if (strA < strB) return isAsc ? -1 : 1;
      if (strA > strB) return isAsc ? 1 : -1;
      return 0;
    });

    setData(dataFilter);
  };

  // Helper to check for valid date
  const isValidDate = (value) => {
    return !isNaN(Date.parse(value));
  };


  const handleSuccessMessage = () => {
    dispatch(resetUserDeletedFlag(false));
  }
  //filter withonly app users
  const updatedUsers = users.filter((user) => user.userType !== USER_TYPE.CLINICIAN)
  const [data, setData] = useState(updatedUsers);


  useEffect(() => {
    if (users?.length != 0) {
      const listOfUsers = users.filter((user) => user.userType !== USER_TYPE.CLINICIAN).map((user) => ({
        ...user,
        totalProgress: getTotalProgress(user)
      }));
      
      // console.log(JSON.stringify(listOfUsers), 'listOfUsers=')
      setData(listOfUsers);
    }
  }, [users])

  const showUserDetails = (userId) => {
    navigate(`/user_details/${userId}`);
  }
  const getTotalProgress = (user) => {
    const data = user.compliance;
    let count = 0;

    if (data.education.scheduled !== 0) {
      count = count + 1;
    }
    if (data.exercise.scheduled !== 0) {
      count = count + 1;
    }
    if (data.questionnaire.scheduled !== 0) {
      count = count + 1;
    }

    const totalScheduled =
      data.education.percent +
      data.exercise.percent +
      data.questionnaire.percent;

    if (count === 0) {
      console.log(user)
      return '-1';
    }
    const totalProgress = totalScheduled / count

    return isNaN(totalProgress) ? 0 : Math.round(totalProgress);

  }


  return (
    <div>
      <div className='  '>
        {isUserDeleted &&
          <Alert severity="success" onClose={handleSuccessMessage}>
            Selected user deleted successfully.
          </Alert>
        }
        <TitleLink
          boxTitle={t('users')}
          subTitle={t('lable_sort_list')}
          enableButton={true}
          buttonTitle={t('add_user')}
          onClick={handleClickOpenAddUser}
          startIcon={<PersonAddAltOutlinedIcon />}
          enabledSearch={true}
          searchComponent={<Search />}
        />

        <TableContainer
          sx={{
            height: 630,
            "& .MuiTableCell-root": {
              border: '1px solid #f3f3f3'
            },
            "&::-webkit-scrollbar-track-piece:start": {
              background: "transparent",
              marginTop: "55px"
            },
            "&::-webkit-scrollbar": {
              width: 6,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "white"
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#ccc",
              borderRadius: 2
            }
          }} >
          {isFilter &&
            <div style={{
              backgroundColor: '#D5F5E3',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontSize: '20px',
              marginBottom: 2
            }}>
              <div style={{ color: 'green', paddingLeft: 10 }}>Search result</div>
              <div>
                <Button onClick={reset}>Clear Filter</Button>
              </div>
            </div>
          }


          <Table stickyHeader size='small' aria-label="sticky table">

            <TableHead
              sx={{
                "& th": {
                  backgroundColor: "#def1fc",
                  color: "black",
                  fontWeight: 600,
                },
                "& th:hover": {
                  backgroundColor: "#c9e8fa",
                }
              }}>
              <TableRow>
                <TableCell onClick={() => sortBy('firstName', isAsc)} >{t('first_name')}</TableCell>
                <TableCell onClick={() => sortBy('lastName', isAsc)}>{t('last_name')}</TableCell>
                <TableCell onClick={() => sortBy('enrollmentDate', isAsc)}>{t('enrollment_date')}</TableCell>
                <TableCell onClick={() => sortBy('startDate', isAsc)}>{t('start_date')}</TableCell>
                <TableCell onClick={() => sortBy('phone', isAsc)}>{t('phone_number')}</TableCell>
                <TableCell onClick={() => sortBy('email', isAsc)}>{t('email')} </TableCell>
                <TableCell onClick={() => sortBy('dob', isAsc)}>{t('dob')}</TableCell>
                <TableCell onClick={() => sortBy('intakeDate', isAsc)}>{t('intake_date')}</TableCell>
                <TableCell onClick={() => sortBy('totalProgress', isAsc)}>{t('progress')}</TableCell>
              </TableRow>
            </TableHead>




            <TableBody>
              {(data && data.length > 0) ? data.map((user, index) => {
                let bgColor = (index % 2 === 0) ? COLOR.odd : COLOR.even;
                return (<TableRow
                  key={user.userId}
                  sx={{ backgroundColor: `${bgColor}` }}
                  onClick={() => showUserDetails(user.userId)}
                >
                  <TableCell scope="row">
                    <Link style={{ color: '#028DD5', textDecoration: 'inherit' }}

                    >
                      {user.firstName}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link style={{ color: '#028DD5', textDecoration: 'inherit' }}

                    >
                      {user.lastName}
                    </Link>
                  </TableCell>
                  <TableCell>
                    {dayjs(user.enrollmentDate).format('MM/DD/YYYY')}
                  </TableCell>
                  <TableCell>
                    {dayjs(user.startDate).format('MM/DD/YYYY')}
                  </TableCell>
                  <TableCell>{formatPhoneNumber(user?.phone)}</TableCell>
                  <TableCell>
                    {user.email}
                  </TableCell>
                  <TableCell>
                    {dayjs(user.dob).format('MM/DD/YYYY')}
                  </TableCell>
                  <TableCell>
                    {(user.intakeDate) ? dayjs(user.intakeDate).format('MM/DD/YYYY') : <span style={{ color: 'red' }}>{t('pending')}</span>}
                  </TableCell>
                  <TableCell align="center" style={{ color: user?.totalProgress==='-1'?'black':user?.totalProgress < 25 ? 'red' : user?.totalProgress < 75 ? '#ffe100' : '#2ecc71' }}>
                    {user?.totalProgress==='-1'?'No Task':user?.totalProgress+'%'}
                  </TableCell>
                </TableRow>)

              }) :
                (<TableRow > <TableCell scope="row" colSpan={8}>{t('loading')}</TableCell></TableRow>)
              }
            </TableBody>

          </Table>
        </TableContainer>

        <Dialog
          open={openAddUser}
          onClose={handleCloseAddUser}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "100%",
                maxWidth: "500px",
                display: 'flex',
                fontFamily: 'Open Sans'
              },
            },
          }}
        >
          <form method='post' id="myform" onSubmit={handleSubmit}>
            <DialogTitle id="alert-dialog-title">
              {t("add_user")}
            </DialogTitle>
            <DialogContent>
              <div style={{ display: 'flex', marginBottom: '10px', marginTop: '10px' }}>
                <div style={{ marginRight: '5px' }}>
                  <TextField
                    name='firstName'
                    size='small'
                    id="outlined-basic"
                    label={t('first_name')}
                    variant="outlined"
                    onChange={handleChange}
                    value={formValues.firstName}
                    error={formErrors.firstName ? true : false}
                  />
                </div>
                <div>
                  <TextField
                    name='lastName'
                    size='small'
                    id="outlined-basic"
                    label={t('last_name')}
                    variant="outlined"
                    onChange={handleChange}
                    value={formValues.lastName}
                    error={formErrors.lastName ? true : false}
                  />
                </div>
              </div>
              <div style={{ display: 'flex', marginBottom: '10px' }}>
                <div style={{ marginRight: '5px' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      name="dob"
                      value={dayjs(dob)}
                      selected={dob}
                      label={t('dob')}
                      onChange={(date) => setDob(date)} />
                  </LocalizationProvider>
                </div>
                <div >
                  <TextField sx={{ minWidth: 225 }} select
                    name="gender"
                    labelid="demo-select-small-label"
                    id="demo-select-small"
                    value={formValues.gender}
                    label={t('gender')}
                    onChange={handleChange}
                  >
                    <MenuItem value={'male'}>{t('male')}</MenuItem>
                    <MenuItem value={'female'}>{t('female')}</MenuItem>
                    <MenuItem value={'other'}>{t('other')}</MenuItem>
                  </TextField>

                </div>
              </div>
              <div style={{ display: 'flex', }}>
                <div style={{ marginRight: '5px' }}>
                  <TextField
                    name='phone'
                    value={formValues.phone}
                    size='small'
                    id="outlined-basic"
                    label={t('phone')}
                    variant="outlined"
                    onChange={handleChange}
                    error={formErrors.phone ? true : false}
                  />
                </div>
                <div>
                  <TextField
                    name='email'
                    value={formValues.email}
                    size='small'
                    id="outlined-basic"
                    label={t('email')}
                    variant="outlined"
                    onChange={handleChange}
                    error={formErrors.email ? true : false}
                  />
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                type="submit"
                color='primary'
                variant="contained"
                autoFocus
              >
                {t('add')}
              </Button>
              <Button
                size='small'
                onClick={handleCloseAddUser}
              >

                {t('cancel')}
              </Button>
            </DialogActions>
          </form>
        </Dialog>

      </div>
    </div>
  );
}

export default Users